import React from 'react'
import { LoaderCircle } from 'lucide-react'
import { Skeleton } from '@/components/ui/skeleton'

/** Placeholder for a photo that is still being processed. */
const PhotoTileSkeleton: React.FC = () => (
  <>
    <Skeleton className="absolute inset-0 rounded-none" />
    <LoaderCircle className="absolute left-1/2 top-1/2 h-5 w-5 -translate-x-1/2 -translate-y-1/2 animate-spin text-muted-foreground" />
  </>
)

export default PhotoTileSkeleton
